import { render, staticRenderFns } from "./AvatarBuilderCategory.vue?vue&type=template&id=7d73e1fb&scoped=true&"
import script from "./AvatarBuilderCategory.vue?vue&type=script&lang=js&"
export * from "./AvatarBuilderCategory.vue?vue&type=script&lang=js&"
import style0 from "./AvatarBuilderCategory.vue?vue&type=style&index=0&id=7d73e1fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d73e1fb",
  null
  
)

export default component.exports